import { Injectable } from '@angular/core';
import { OrderConfirm } from '../../../model/myria/api/OrderConfirm';
import { IOrder } from '../../../model/models/order/order-interface';
import { SEND_AMOUNT_TYPE_NEW_ORDER } from '../../../model/myria/app/transactionPreview';
import { DeliveryMethodType } from '../../../model/types/delivery-method-type';
import { DELIVERY_METHOD } from '../app-variables';
import { LoggerEvent, LoggerProvider } from '../../logger/logger';
import { PaymentMethodType } from '../../../model/types/payment-method-type';

@Injectable()
export class CustomerProviderMapperProvider {

  static orderToOrderConfirm(order: IOrder, statusOnHold: boolean, veracityDisclosure: boolean, isValidate: boolean, acceptsTermsAndConditions: boolean, fetchRequiredFields: boolean = false): OrderConfirm {
    let deliveryId = 0;

    switch (order.deliveryMethodInternal) {
      case DeliveryMethodType.OfficePickup:
        deliveryId = DELIVERY_METHOD.CASH_PICKUP.Id;
        break;
      case DeliveryMethodType.BankDeposit:
      case DeliveryMethodType.DebitCard:
        deliveryId = DELIVERY_METHOD.BANK_DEPOSIT.Id;
        break;
      case DeliveryMethodType.HomeDelivery:
        deliveryId = DELIVERY_METHOD.HOME_DELIVERY.Id;
        break;
      case DeliveryMethodType.MobilePayment:
        deliveryId = DELIVERY_METHOD.MOBILE_PAYMENT.Id;
        break;
      case DeliveryMethodType.UPI:
        deliveryId = DELIVERY_METHOD.UPI.Id;
        break;
      case DeliveryMethodType.Alipay:
        deliveryId = DELIVERY_METHOD.ALIPAY.Id;
        break;
      case DeliveryMethodType.PIX:
        deliveryId = DELIVERY_METHOD.PIX.Id;
        break;
      case DeliveryMethodType.BreB:
        deliveryId = DELIVERY_METHOD.BREB.Id;
        break;
      case DeliveryMethodType.PagoMovil:
        deliveryId = DELIVERY_METHOD.PAGO_MOVIL.Id;
        break;
    }
    if (!deliveryId)
      LoggerProvider.error(this, LoggerEvent.ProviderException, 'Unsupported delivery method for staged transaction: ' + order.deliveryMethod);

    let agentId = undefined;
    let locationId = undefined;
    if (order.agentTo && order.agentTo.isOpenPayment) {
      agentId = order.agentTo.id;
    }
    else if (order.agentToLocation) {
      agentId = order.agentToLocation.agentId;
      locationId = order.agentToLocation.locationId;
    }
    if (order.deliveryMethod === DeliveryMethodType.BankDeposit) {
      // Would otherwise clobber the correspondent finalizeRecipient resolved.
      if (order.bankDepositProvider) {
        agentId = order.bankDepositProvider.correspondentId;
        locationId = order.bankDepositProvider.correspondentLocId;
      }
      else {
        agentId = order.recipient.bankAgentId;
        locationId = order.recipient.bankAgentLocationId;
      }
    }

    if (order.paymentMethod === PaymentMethodType.StagedRia && order.deliveryMethodInternal === DeliveryMethodType.MobilePayment) {
      if (order.agentToLocation) {
        locationId = order.agentToLocation.locationId;
      }
    }

    // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    //this.order.agentToLocation = { agentId: this.destinationCountry.DefaultOpenPaymentPayAgentId, locationId: this.destinationCountry.DefaultOpenPaymentPayAgentLocId };

    const confirm: OrderConfirm = {
      ReSendOrderId: order.orderId,
      BeneficiaryAsACustomerId: (order.recipient) ? order.recipient.id : null,
      DeliveryMethodId: deliveryId.toString(),
      CountryTo: order.countryTo,
      SendAmount: (order.amountFrom) ? order.amountFrom.toString() : null,
      PayoutAmount: (order.amountTo) ? order.amountTo.toString() : null,
      ExchangeRate: (order.exchangeRatePromo) ? order.exchangeRatePromo.toString() : ((order.exchangeRate) ? order.exchangeRate.toString() : null),
      SendSurcharge: '0', // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! always 0 ?
      SendFee: (order.customerFee) ? order.customerFee.toString() : '0',
      Tax: (order.customerTax) ? order.customerTax.toString() : '0',
      CurrencyFrom: order.currencyFrom,
      PromoCode: (order.promoCode) ? order.promoCode : order.promoEngineCode,
      PromoId: order.promoId,
      PromoLockId: 0, // new change to unlock promotions on cst //newOrder.Transaction.TransIdLocked ? newOrder.Transaction.TransIdLocked : 0,
      CurrencyTo: order.currencyTo,
      UsePromo: order.isPromoValid,
      Amount: (order.shouldCalcAmountFrom) ? (order.amountTo ? order.amountTo.toString() : null) : (order.amountFrom ? order.amountFrom.toString() : null),
      AmountTypeId: (order.shouldCalcAmountFrom) ? SEND_AMOUNT_TYPE_NEW_ORDER.PAYOUT : SEND_AMOUNT_TYPE_NEW_ORDER.SEND,
      PayAgentId: agentId,
      PayAgentLocId: locationId,
      SendOrderRegardlessOnHold: statusOnHold,
      DeviceId: order.deviceId ? order.deviceId : '0',
      DeviceTime: new Date().toISOString(),
      LocalDate: new Date().toISOString(),
      ProvidedFields: order.stagedProvidedFields || [],
      VeracityDisclosure: veracityDisclosure,
      OnlyValidate: isValidate,
      AcceptsTermsAndConditions: acceptsTermsAndConditions,
      OtpActionRequest: order.otpActionRequest ? order.otpActionRequest : undefined,
      PaymentMethodId: order.paymentMethod,
      NonThirdPartyDisclaimer: order.nonThirdPartyDisclaimer ? order.nonThirdPartyDisclaimer : null,
      MerchantWalletProxyNumber: order.merchantWalletProxyNumber ? order.merchantWalletProxyNumber : undefined,
      CustomerFundingState: order.customerFundingState ? order.customerFundingState : undefined,
      LoginType: order.LoginType,
      TokenReference: order.TokenReference,
      RecipientDebitCard: order.recipientDebitCard ? order.recipientDebitCard : undefined,
      fetchRequiredFields: fetchRequiredFields,
      AccertifyDeviceId: order.accertifyDeviceId ? order.accertifyDeviceId : null,
      PromoType: order.promoType ? order.promoType : null,
      PromoSourcePlatform: order.promoSourcePlatform ? order.promoSourcePlatform : null,
      // entityId stays wallet-only; no bank equivalent.
      IsSmartRouting: !!(order.bankDepositProvider || (order.wallet && order.isSmartRouting)),
      entityId: (order.wallet && order.wallet.EntityID) ? order.wallet.EntityID : null,
      providerId: order.bankDepositProvider ? order.bankDepositProvider.providerId
        : (order.wallet && order.wallet.ProviderId) ? order.wallet.ProviderId : null
    }
    return confirm;
  }
}



// WEBPACK FOOTER //
// ./src/providers/myria/customer-provider/customer-provider-mapper.ts